export const dashboardGraphsTheme = {
  compare: {
    note: 'palette.tertiary.60',
    panelTitle: 'palette.tertiary.90',
    table: {
      cellText: 'palette.tertiary.90',
      headerText: 'palette.tertiary.60',
      rowBorderColor: 'palette.tertiary.10',
    },
    tile: {
      bg: 'palette.surface.4',
      borderColor: 'palette.tertiary.10',
      borderRadius: '8px',
      borderWidth: '1px',
      boxShadow: 'palette.tertiary.20:0.1',
    },
    trend: {
      badge: {
        bg: 'palette.black:0.6',
        neutral: 'palette.white',
      },
      negative: 'palette.error.60',
      positive: 'palette.success.20',
    },
  },
  graph: {
    legendLabelColor: 'palette.tertiary.95',
    xAxisLabelColor: 'palette.primary.60',

    axisStroke: 'palette.tertiary.10',
    brushFill: 'palette.surface.1',
    brushStroke: 'palette.tertiary.10',
    cursorStroke: 'palette.surface.4',

    tooltipBg: 'palette.surface.5',
    tooltipInfoDivider: 'palette.tertiary.10',
    tooltipInfoKey: 'palette.tertiary.60',
    tooltipTitle: 'palette.tertiary.90',
  },
};
